import React from 'react';

const ParentsSchools = () => {
  return (
    <section className="py-20 bg-slate-950">
      <div className="container mx-auto px-6">
        <div className="text-center mb-12">
          <h2 className="text-3xl font-bold text-slate-100 mb-4">Built for Parents and Schools Too</h2>
          <p className="text-slate-400">Behind every motivated student is a parent or teacher who cares.</p>
        </div>

        <div className="grid md:grid-cols-2 gap-8 max-w-4xl mx-auto">
          <div className="bg-slate-900 p-8 rounded-2xl border border-slate-800">
            <h3 className="text-xl font-bold text-slate-100 mb-4 flex items-center gap-2">
              <span className="text-cyan-500">For Parents</span>
            </h3>
            <ul className="space-y-3 text-slate-400">
              <li>• Aligned with school topics (Class 5–12).</li>
              <li>• Clear reports and progress tracking.</li>
              <li>• Concept-first approach improves exams.</li>
            </ul>
          </div>

          <div className="bg-slate-900 p-8 rounded-2xl border border-slate-800">
            <h3 className="text-xl font-bold text-slate-100 mb-4 flex items-center gap-2">
              <span className="text-cyan-500">For Schools</span>
            </h3>
            <ul className="space-y-3 text-slate-400">
              <li>• Flip your classroom or support revision.</li>
              <li>• Cohort-based access and analytics.</li>
              <li>• Consistent visual language.</li>
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ParentsSchools;